import * as React from 'react';
import styled from 'styled-components';
import { withProps } from '../../../theme/styled-components';

export interface Props {
  src: string;
  baseUrl: string;
  className?: string;
  placeHolderSrc: string;
}

export interface State {
  loaded: boolean;
}

export class Image extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }
  handleLoadImage = () => {
    this.setState({ loaded: true });
  };

  render() {
    const { src, baseUrl, className, placeHolderSrc } = this.props;
    const { loaded } = this.state;
    return (
      <Wrapper className={className}>
        {src ? (
          <Img
            src={`${baseUrl}/image/${src}`}
            onLoad={this.handleLoadImage}
            loaded={loaded}
          />
        ) : (
          <img src={placeHolderSrc} />
        )}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
`;

const Img = withProps<{ loaded: boolean }>()(styled.img)`
  trasition: opacity .3s;
  opacity: ${({ loaded }) => (loaded ? '1' : '0')};
`;
